module.exports = __webpack_public_path__ + "static/media/26UNRWA6.54744d8c.jpg";